import React from 'react';
import './AdminSidebarRow.css';

/**
 * @param {{
 *   active?: boolean,
 *   count?: number | string | null,
 *   tone?: 'critical' | 'signal' | 'ambient' | 'ok' | 'neutral',
 *   dot?: boolean,
 *   dotColor?: string | null,
 *   children?: React.ReactNode,
 *   className?: string
 * } & React.HTMLAttributes<HTMLDivElement> & React.ButtonHTMLAttributes<HTMLButtonElement>} props
 */
function AdminSidebarRow({
  active = false,
  count = null,
  tone = 'neutral',
  dot = true,
  dotColor = null,
  children,
  className = '',
  onClick,
  ...rest
}) {
  const Element = onClick ? 'button' : 'div';
  const elementProps = onClick ? { type: 'button' } : {};

  return (
    <Element
      className={`au-sidebar-row au-scope au-sidebar-row--${tone}${active ? ' is-active' : ''}${onClick ? ' is-interactive' : ''}${className ? ` ${className}` : ''}`}
      onClick={onClick}
      style={dotColor ? { '--au-sidebar-dot': dotColor } : undefined}
      {...elementProps}
      {...rest}
    >
      <span className="au-sidebar-row__main">
        {dot ? <span className="au-sidebar-row__dot" aria-hidden="true" /> : null}
        <span className="au-sidebar-row__label">{children}</span>
      </span>
      {count !== null && count !== undefined ? <span className="au-sidebar-row__count">{count}</span> : null}
    </Element>
  );
}

export default AdminSidebarRow;
